import { Box, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { BadgeIndicator, vars } from '@tgtg/kit';
import { type ReactNode } from 'react';
import { NavLink } from 'react-router';

const primaryTypographyProps = {
  fontWeight: 500,
  fontFamily: vars.typography.labels.medium.fontFamily,
  fontSize: vars.typography.labels.medium.fontSize,
};

interface DrawerNavItemProps {
  badgeContent?: number;
  icon: ReactNode;
  label: ReactNode;
  to: string;
}

const DrawerNavItem = ({ badgeContent, icon, label, to }: DrawerNavItemProps) => {
  const iconSlot = badgeContent ? (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      {icon}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          transform: 'translate(50%, -50%)',
          pointerEvents: 'none',
        }}
      >
        <BadgeIndicator variant='number' value={badgeContent} />
      </Box>
    </Box>
  ) : (
    icon
  );

  return (
    <ListItem
      disablePadding
      sx={{
        borderRadius: vars.radius.medium,
        overflow: 'hidden',
      }}
    >
      <ListItemButton
        component={NavLink}
        to={to}
        sx={{
          color: vars.color.content.subtle,
          '&.active': {
            color: vars.color.content.brand,
            backgroundColor: vars.color.surface.interactive.opacityOverlayPressed,
          },
          '&:hover': {
            color: vars.color.content.brand,
            backgroundColor: vars.color.surface.interactive.opacityOverlayHover,
          },
        }}
      >
        <ListItemIcon
          sx={{
            color: 'inherit',
            minWidth: `calc(18px + ${vars.spacing.neutral.large})`,
          }}
        >
          {iconSlot}
        </ListItemIcon>
        <ListItemText primary={label} primaryTypographyProps={primaryTypographyProps} />
      </ListItemButton>
    </ListItem>
  );
};

export default DrawerNavItem;
